import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { SemanticPathService } from '@spartacus/core';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { ActiveCartService, MultiCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';

@Injectable({
  providedIn: 'root'
})
export class CheckoutStep2Guard implements CanActivate {
  constructor(
    protected activeCartService: ActiveCartService,
    protected router: Router,
    protected semanticPathService: SemanticPathService,
    protected multiCartService: MultiCartService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([this.activeCartService.getActiveCartId(), this.activeCartService.getLoading()]).pipe(
      first(([, isLoading]) => !isLoading),
      tap(([cartId]) => {
        if (cartId) {
          this.multiCartService.reloadCart(cartId);
        }
      }),
      switchMap(() => combineLatest([this.activeCartService.getActive(), this.activeCartService.getLoading()])),
      first(([, isLoading]) => !isLoading),
      map(([cart]) => {
        if (this.isEmptyCart(cart) || this.isAnonymous(cart)) {
          return this.router.parseUrl(this.semanticPathService.get('cart'));
        }
        return true;
      })
    );
  }

  private isEmptyCart(cart: Cart): boolean {
    return !cart || !cart['entryGroups'] || cart['entryGroups'].length === 0;
  }

  private isAnonymous(cart: Cart): boolean {
    return cart?.user?.uid === 'anonymous';
  }
}
